import { createContext, useContext, useState, useEffect, useCallback } from "react";

const CartCtx = createContext(null);
const KEY = "em_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(items)); } catch { /* ignore */ }
  }, [items]);

  const add = useCallback((product, size) => {
    setItems((prev) => {
      const k = `${product.id}|${size || ""}`;
      const idx = prev.findIndex((i) => `${i.productId}|${i.size || ""}` === k);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], qty: copy[idx].qty + 1 };
        return copy;
      }
      return [...prev, {
        productId: product.id,
        name: product.name,
        price: product.price,
        size: size || "",
        qty: 1,
        imageUrl: product.imageUrl || null,
      }];
    });
  }, []);

  const setQty = useCallback((idx, qty) =>
    setItems((prev) => prev.map((i, j) => (j === idx ? { ...i, qty: Math.max(1, qty) } : i))), []);

  const remove = useCallback((idx) =>
    setItems((prev) => prev.filter((_, j) => j !== idx)), []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((n, i) => n + i.qty, 0);
  const total = Math.round(items.reduce((s, i) => s + i.price * i.qty, 0) * 100) / 100;

  return (
    <CartCtx.Provider value={{ items, add, setQty, remove, clear, count, total }}>
      {children}
    </CartCtx.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartCtx);
  if (!ctx) throw new Error("useCart must be used within CartProvider");
  return ctx;
}
